import React from "react";
import "./Visioncard.css";

function Visioncrad() {
  return (
    <div className="vision-card-parent">
    <div className="vison-card">
      <div className="card-title">For Students:</div>
      <div className="card-desc">
        To provide tailored tools and counseling that unlock each student’s unique talents and inspire lifelong learning.

      </div>
    </div>
    <div className="vison-card">
      <div className="card-title">For Counselors:</div>
      <div className="card-desc">
        To empower counselors with innovative technology that enhances their reach, effectiveness, and impact.
      </div>
    </div>
    <div className="vison-card">
      <div className="card-title">For Institutions</div>
      <div className="card-desc">
        To partner with educational and corporate institutions to foster holistic growth and career readiness at scale.
      </div>
    </div>
    </div>
  );
}

export default Visioncrad;
